import { useState } from "react";
import {
    Box,
    IconButton,
    InputBase,
    Typography,
    Select,
    MenuItem,
    FormControl,
    useTheme,
    useMediaQuery
} from "@mui/material";
import {
    Search,
    Message,
    DarkMode,
    LightMode,
    Notifications,
    Menu,
    Help,
    Close,
    VideoChat
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { setMode, setLogout } from "state";
import { useNavigate } from "react-router-dom";
import FlexBetween from "components/FlexBetween";



const Navbar = () => {
    const [toggleMenu, setToggleMenu] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state) => state.user);
    const theme = useTheme();
    const neutralLight = theme.palette.neutral.light;
    const dark = theme.palette.neutral.dark;
    const background = theme.palette.background.default;
    const primaryLight = theme.palette.primary.light;
    const alt = theme.palette.background.alt;
    const nonMobileScreen = useMediaQuery("(min-width: 924px)");
    // console.log(nonMobileScreen);


    const fullName = user?.firstname && user?.lastname ? `${user.firstname} ${user.lastname}` : '';

    return (
        <FlexBetween padding="1rem 2%" backgroundColor={alt} position="fixed" top="0" zIndex="1000" width="100%">

            <FlexBetween gap='1.75rem'>
                <Box 
                display="flex" justifyContent="center" alignItems="center"
                >
                    <img src="https://res.cloudinary.com/dc7es8xpv/image/upload/v1709056414/assets/kairos_logo_1_1_ynvfzn.png" alt="Logo" width="90rem" />
                    <Typography
                        fontWeight="bold"
                        fontSize="clamp(1rem, 2rem, 2.25rem)"
                        color="#a591bd"
                        onClick={() => {
                            navigate("/")
                        }}
                        sx={{
                            "&:hover": {
                                color: primaryLight,
                                cursor: "pointer"
                            }
                        }}
                    >
                        Kairos
                    </Typography>
                </Box>


                {/* Serch  */}
                {nonMobileScreen && (
                    <FlexBetween backgroundColor={neutralLight}
                        borderRadius="9px"
                        gap="3rem"
                        p="0.1rem 
                        0.5rem"
                    >
                        <InputBase placeholder="Serch..." />
                        <IconButton>
                            <Search />
                        </IconButton>
                    </FlexBetween>
                )}
            </FlexBetween>

            {/* Desktop Nav */}
            {nonMobileScreen ? (
                <FlexBetween gap="2rem">
                    <IconButton onClick={() => {
                        dispatch(setMode())
                    }}>
                        {theme.palette.mode === "dark" ? (
                            <DarkMode sx={{ fontSize: '25px' }} />
                        ) : (
                            <LightMode sx={{ color: dark, fontSize: '25px' }} />
                        )}
                    </IconButton>

                    <IconButton>
                        <Message sx={{ fontSize: '25px' }} />
                    </IconButton>

                    <IconButton onClick={() => {
                        navigate("/videochat");
                    }}>
                        <VideoChat />
                    </IconButton>

                    <IconButton>
                        <Notifications sx={{ fontSize: '25px' }} />
                    </IconButton>

                    <IconButton>
                        <Help sx={{ fontSize: '25px' }} />
                    </IconButton>

                    <FormControl variant="standard" value={fullName}>
                        <Select value={fullName}
                            sx={{
                                backgroundColor: neutralLight,
                                width: "150px",
                                borderRadius: "0.25rem",
                                p: "0.25rem 1rem",
                                "& .MuiSvgIcon-root": {
                                    pr: "0.25rem",
                                    width: "3rem",
                                },
                                "& .MuiSelect-select:focus": {
                                    backgroundColor: neutralLight,
                                },
                            }}
                            input={<InputBase />}
                        >
                            <MenuItem value={fullName}>
                                <Typography>
                                    {fullName}
                                </Typography>
                                <MenuItem onClick={() => dispatch(setLogout())}>
                                    Logout
                                </MenuItem>
                            </MenuItem>
                        </Select>
                    </FormControl>
                </FlexBetween>
            ) : (
                <IconButton onClick={() => {
                    setToggleMenu(!toggleMenu);
                }}>
                    <Menu />
                </IconButton>
            )}

            {/* Mobile Nav  */}
            {!nonMobileScreen && toggleMenu && (
                <Box
                    position="fixed"
                    right="0"
                    bottom="0"
                    height="100%"
                    zIndex="10"
                    maxWidth="500px"
                    minWidth="300px"
                    backgroundColor={background}
                >
                    {/* Close Icon  */}
                    <Box display="flex" justifyContent="flex-end" p="1rem">
                        <IconButton onClick={() => {
                            setToggleMenu(!toggleMenu);
                        }}>
                            <Close />
                        </IconButton>
                    </Box>

                    {/* Menu Items  */}
                    <FlexBetween display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        gap="3rem"

                    >
                        <IconButton onClick={() => {
                            dispatch(setMode())
                        }} sx={{ fontSize: '25px' }}
                        >
                            {theme.palette.mode === "dark" ? (
                                <DarkMode sx={{ fontSize: '25px' }} />
                            ) : (
                                <LightMode sx={{ color: dark, fontSize: '25px' }} />
                            )}
                        </IconButton>

                        <IconButton>
                            <Message sx={{ fontSize: '25px' }} />
                        </IconButton>

                        <IconButton>
                            <Notifications sx={{ fontSize: '25px' }} />
                        </IconButton>

                        <IconButton>
                            <Help sx={{ fontSize: '25px' }} />
                        </IconButton>

                        <FormControl variant="standard" value={fullName}>
                            <Select value={fullName}
                                sx={{
                                    backgroundColor: neutralLight,
                                    width: "150px",
                                    borderRadius: "0.25rem",
                                    p: "0.25rem 1rem",
                                    "& .MuiSvgIcon-root": {
                                        pr: "0.25rem",
                                        width: "3rem",
                                    },
                                    "& .MuiSelect-select:focus": {
                                        backgroundColor: neutralLight,
                                    },
                                }}
                                input={<InputBase />}
                            >
                                <MenuItem value={fullName}>
                                    <Typography>
                                        {fullName}
                                    </Typography>
                                    <MenuItem onClick={() => dispatch(setLogout())}>
                                        Logout
                                    </MenuItem>
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </FlexBetween>

                </Box>
            )}
        </FlexBetween>
    )
}

export default Navbar;